import axios from "axios";
import tracking from "../utils/datalayer.js";

const cartUpdateEvent = new Event("cart-update");
const cartShowEvent = new Event("cart-show");

var cart = {
    init: function() {
        // Toggle buttons
        let $toggleBtns = document.querySelectorAll(".js-cart-pane-toggle");
        if ($toggleBtns.length > 0) {
            this.toggleButtons($toggleBtns);
        }

        // Buy buttons
        let $buyBtns = document.querySelectorAll(".js-buy");
        if ($buyBtns.length > 0) {
            this.buyButtons($buyBtns);
        }

        // Plus/minus btns
        let $plusMinusBtns = document.querySelectorAll(
            ".js-product-up, .js-product-down"
        );
        if ($plusMinusBtns.length > 0) {
            this.plusMinusButtons($plusMinusBtns);
        }

        // Quantity input field
        let $quantityInputs = document.querySelectorAll(".js-product-quantity");
        if ($quantityInputs.length > 0) {
            this.quantityInputs($quantityInputs);
        }

        // Remove buttons
        let $removeBtns = document.querySelectorAll(".js-delete");
        if ($removeBtns.length > 0) {
            this.removeButtons($removeBtns);
        }
    },

    toggleButtons: function($toggleBtns) {
        $toggleBtns.forEach((btn) => {
            btn.addEventListener("click", (e) => {
                e.preventDefault();
                window.dispatchEvent(cartShowEvent);
            });
        });
    },

    buyButtons: function($buyBtns) {
        $buyBtns.forEach((btn) => {
            btn.addEventListener("click", (e) => {
                e.preventDefault();
                btn.classList.add("btn-loading");
                axios
                    .post("/umbraco/surface/cart/add", {
                        contextId: window.umbracoContext.id,
                        productIds: btn.dataset.itemId,
                    })
                    .then((response) => {
                        if (response.status === 200) {
                            window.dispatchEvent(cartUpdateEvent);
                            btn.classList.remove("btn-loading");
                        }
                    })
                    .catch((error) => {
                        console.error(error); // todo
                    });
            });
        });
    },

    removeButtons: function($removeBtns) {
        $removeBtns.forEach((btn) => {
            btn.addEventListener("click", (e) => {
                this.trackRemoveEvent(btn.dataset.id, true);
            });
        });
    },

    plusMinusButtons: function($plusMinusBtns) {
        $plusMinusBtns.forEach((btn) => {
            btn.addEventListener("click", (e) => {
                let $inputs = btn
                    .closest(".js-cart-item")
                    .querySelectorAll(".js-product-quantity");
                let up = btn.classList.contains("js-product-up");
                $inputs.forEach((input) => {
                    let val = parseInt(input.value);
                    val = up ? val + 1 : val - 1;
                    input.value = Math.max(0, val);
                });
                if (up) {
                    this.trackAddEvent(btn.dataset.id);
                } else {
                    this.trackRemoveEvent(btn.dataset.id);
                }
                this.updateCart();
            });
        });
    },

    quantityInputs: function($quantityInputs) {
        $quantityInputs.forEach((input) => {
            let $inputs = input
                .closest(".js-cart-item")
                .querySelectorAll(".js-product-quantity");
            input.addEventListener("blur", () => {
                $inputs.forEach((i) => {
                    i.value = input.value;
                });
                this.updateCart();
            });
        });
    },

    trackRemoveEvent: function(id, clear = false) {
        var item = window.trackingData.items.find(
            (item) => item.item_id === id
        );
        item.quantity = clear ? item.quantity : 1;
        var data = {
            ...window.trackingData,
            ...{ event: "remove_from_cart", items: [item] },
        };
        tracking.removeFromCart(data);
    },

    trackAddEvent: function(id) {
        var item = window.trackingData.items.find(
            (item) => item.item_id === id
        );
        tracking.addToCart(item);
    },

    updateCart: function() {
        let data = {
            contextId: window.umbracoContext.id,
            cartLines: [],
        };

        document.querySelectorAll(".js-cart-item").forEach((row) => {
            let productIdInput = row.querySelector("input[name='productId']");
            let contextIdInput = row.querySelector("input[name='contextId']");
            let quantityInput = row.querySelector("input.js-product-quantity");
            if (
                productIdInput !== null &&
                productIdInput.value !== undefined &&
                quantityInput !== null &&
                quantityInput.value !== undefined
            ) {
                data.cartLines.push({
                    contextId: contextIdInput.value,
                    productId: productIdInput.value,
                    quantity: quantityInput.value,
                });
            }
        });

        axios
            .post("/umbraco/surface/cart/update", data)
            .then(
                (response) => (window.location.href = response.data.url || "?")
            )
            .catch((error) => alert("An error occured. Sorry.")); // todo!!!
    },
};

export default cart;
